import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";
import CreateQualityParameterModal from "../QualityParameters/CreateQualityParameterModal";

const EditQualityRules = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();
    const location = useLocation();
    console.log(location);

    // select dropdown
    const [parameter, setParameter] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
        watch,
    } = useForm();

    const currentItem = watch("item");
    const expected_result = Number(watch("expected_result"));
    const tolerance = Number(watch("tolerance"));

    const lower_limit =
        expected_result && tolerance
            ? expected_result - (expected_result / 100) * tolerance
            : 0;

    const higher_limit =
        expected_result && tolerance
            ? expected_result + (expected_result / 100) * tolerance
            : 0;

    const TypeMasterQuery = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const TypeMasterQCSeverityQueryData = TypeMasterQuery.useFetch({
        params: {
            q: "QC Severity",
            c: "category",
        },
    });

    const TypeMasterQCRulesQueryData = TypeMasterQuery.useFetch({
        params: {
            q: "QC Rules",
            c: "category",
        },
    });

    const { useFetch: useFetchParameters } = useAPIQuery({
        key: "item-parameter-association",
        endpoint: "/api/parameter-association/",
    });
    const {
        data: parameters,
        isLoading: parametersLoading,
        isFetching: fetchingParameters,
    } = useFetchParameters({
        params: {
            q: currentItem?.value,
            c: "item_id",
        },
        enabled: !!currentItem,
    });

    const { useUpdate } = useAPIQuery({
        key: "quality_rules",
        endpoint: "/api/quality-rules/",
    });

    const handleUpdateQualityRules = (data) => {
        Swal.fire({
            title: "Quality Rules Updated!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorQualityRules = (data) => {
        Swal.fire({
            title: "Error Updating Quality Rules",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useUpdate({
        onSuccess: handleUpdateQualityRules,
        onError: handleErrorQualityRules,
        retry: 2,
    });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var quality_rules = {
            parameter_id: data.parameter.value,
            item_id: data.item.value,
            lower_limit: lower_limit,
            higher_limit: higher_limit,
            tolerance: Number(data.tolerance),
            parameter_severity: data.severity.value,
            use_rule: data?.qc_rule?.value,
            expected_result: data.expected_result,
            updated_by: userID,
        };

        mutate({
            id: location.state.editpost.id,
            data: quality_rules,
        });
    };

    // Pre Population of Particular Product details
    useEffect(() => {
        const editQuality = location.state.editpost;
        // defaultValues is a react form hook.
        if (editQuality) {
            var defaultValues = {};
            defaultValues.lower_limit = editQuality.lower_limit;
            defaultValues.higher_limit = editQuality.higher_limit;
            defaultValues.tolerance = editQuality.tolerance;
            // defaultValues.rule_func = editQuality.rule_func;
            // defaultValues.arguments = editQuality.arguments;
            defaultValues.expected_result = editQuality.expected_result;

            const getParameter = {
                value: editQuality.parameter?.id,
                label: editQuality.parameter?.parameter_name,
            };
            defaultValues.parameter = getParameter;
            defaultValues.severity = {
                value: editQuality?.parameter_severity,
                label: editQuality?.parameter_severity,
            };
            defaultValues.qc_rule = {
                value: editQuality?.use_rule,
                label: editQuality?.use_rule,
            };

            const getItem = {
                value: editQuality.item?.id,
                label: editQuality.item?.item_name,
            };

            defaultValues.item = getItem;

            reset(defaultValues);
        }
    }, []);

    useEffect(() => {
        if (data) {
            setParameter(data.parameters);
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Edit Quality Rules </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Select Item
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={data?.item
                                                    ?.filter(
                                                        (i) =>
                                                            i?.category?.toLowerCase() ===
                                                                "Raw Material"?.toLowerCase() ||
                                                            i?.category?.toLowerCase() ===
                                                                "WIP"?.toLowerCase() ||
                                                            i?.category?.toLowerCase() ===
                                                                "FG"?.toLowerCase()
                                                    )
                                                    ?.map((info) => ({
                                                        value: info?.id,
                                                        label: info?.item_name,
                                                        ...info,
                                                    }))}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="item"
                                        control={control}
                                    />
                                    {errors.item && (
                                        <span className="fs-8 text-danger">
                                            Item is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Select Parameters
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <div className="row">
                                        <div className="col-10">
                                            <Controller
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        options={
                                                            parameters
                                                                ? parameters?.results?.data?.map(
                                                                      (p) => ({
                                                                          value: p
                                                                              ?.parameter
                                                                              ?.id,
                                                                          label: p
                                                                              ?.parameter
                                                                              ?.parameter_name,
                                                                          ...p,
                                                                      })
                                                                  )
                                                                : []
                                                        }
                                                        isLoading={
                                                            parametersLoading ||
                                                            fetchingParameters
                                                        }
                                                        isClearable={true}
                                                        id="select-forms-item"
                                                    />
                                                )}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                name="parameter"
                                                control={control}
                                            />
                                            {errors.item && (
                                                <span className="fs-8 text-danger">
                                                    Item is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-2 d-flex align-items-center justify-content-start">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                data-bs-toggle="modal"
                                                data-bs-target="#create-quality-parameters-modal"
                                                disabled={!currentItem}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Severity
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={
                                                    TypeMasterQCSeverityQueryData?.data?.results?.data?.map(
                                                        (tm) => ({
                                                            value: tm?.value,
                                                            label: tm?.name,
                                                        })
                                                    ) ?? []
                                                }
                                                isLoading={
                                                    TypeMasterQCSeverityQueryData?.isLoading
                                                }
                                                isClearable={true}
                                                id="select-forms-severity"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="severity"
                                        control={control}
                                    />
                                    {errors.severity && (
                                        <span className="fs-8 text-danger">
                                            Severity is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        QC Rule
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={
                                                    TypeMasterQCRulesQueryData?.data?.results?.data?.map(
                                                        (tm) => ({
                                                            value: tm?.value,
                                                            label: tm?.name,
                                                        })
                                                    ) ?? []
                                                }
                                                isLoading={
                                                    TypeMasterQCRulesQueryData?.isLoading
                                                }
                                                isClearable={true}
                                                id="select-forms-qc_rule"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="qc_rule"
                                        control={control}
                                    />
                                    {errors.qc_rule && (
                                        <span className="fs-8 text-danger">
                                            QC rule is required
                                        </span>
                                    )}
                                </div>
                                {watch("qc_rule")?.value === "Exact" ? (
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">
                                            Expected result
                                            <span className="fs-8 text-danger">
                                                {" "}
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter excepted result"
                                            id="email-forms-expected_result"
                                            {...register("expected_result", {
                                                required: true,
                                            })}
                                        />
                                        {errors.expected_result && (
                                            <span className="fs-8 text-danger">
                                                Expected Result is required
                                            </span>
                                        )}
                                    </div>
                                ) : watch("qc_rule")?.value === "Tolerance" ? (
                                    <>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Expected result
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                type="number"
                                                step={"any"}
                                                className="form-control"
                                                placeholder="Enter excepted result"
                                                id="email-forms-expected_result"
                                                {...register(
                                                    "expected_result",
                                                    {
                                                        required: true,
                                                    }
                                                )}
                                            />
                                            {errors.expected_result && (
                                                <span className="fs-8 text-danger">
                                                    Expected Result is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Tolerance
                                                <span className="fs-8 text-danger">
                                                    {" "}
                                                    *
                                                </span>
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type="number"
                                                    step={"any"}
                                                    className="form-control"
                                                    placeholder="Enter tolerance (0-100)"
                                                    id="text-forms-tolerance"
                                                    {...register("tolerance", {
                                                        required:
                                                            "Tolerance is required",
                                                        min: {
                                                            value: 0,
                                                            message:
                                                                "Tolerance must be at least 0",
                                                        },
                                                        max: {
                                                            value: 100,
                                                            message:
                                                                "Tolerance cannot exceed 100",
                                                        },
                                                    })}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">
                                                        %
                                                    </span>
                                                </div>
                                            </div>
                                            {errors.tolerance && (
                                                <span className="fs-8 text-danger">
                                                    {errors.tolerance.message}
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Lower Limit
                                            </label>
                                            <p>{lower_limit}</p>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <label className="form-label">
                                                Higher Limit
                                            </label>
                                            <p>{higher_limit}</p>
                                        </div>
                                    </>
                                ) : null}

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-quality-rules-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-update-quality-rules"
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <CreateQualityParameterModal item={currentItem} />
        </>
    );
};

export default EditQualityRules;
